import { Fragment, useEffect } from 'react';
import NProgress from 'nprogress';

import { Box, CircularProgress } from '@mui/material';

const BoxStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
};

const Loader = () => {
  const renderLoadingBox = (
    <Box sx={BoxStyles}>
      <CircularProgress />
    </Box>
  );

  NProgress.configure({
    showSpinner: false,
  });

  useEffect(() => {
    NProgress.start();
    return () => NProgress.done();
  }, []);

  return <Fragment>{renderLoadingBox}</Fragment>;
};

export default Loader;
